import { render, staticRenderFns } from "./OnlineSwitch.vue?vue&type=template&id=66c4c817&scoped=true&"
import script from "./OnlineSwitch.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OnlineSwitch.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OnlineSwitch.vue?vue&type=style&index=0&id=66c4c817&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c4c817",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66c4c817')) {
      api.createRecord('66c4c817', component.options)
    } else {
      api.reload('66c4c817', component.options)
    }
    module.hot.accept("./OnlineSwitch.vue?vue&type=template&id=66c4c817&scoped=true&", function () {
      api.rerender('66c4c817', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorServicePrices/components/OnlineSwitch.vue"
export default component.exports